import { DepartmentApi } from '../../api/models/department-api';

export class Department
{
    departmentCode: string = '';
    departmentFR: string = '';
    departmentPath: string = '';
    departmentId: string = '';
    departmentLabel: string = '';

    informationServicesManager!: string;
    salesManager!: string;
    codeERP!: string;
    technicalDepartment!: string;
    ressources!: string;

    public static mapperFromApi (mapperFromApi: DepartmentApi): Department
    {
        return Object.assign(new Department(), mapperFromApi);
    }
}